// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__26sWd","tab":"Tabs_tab__2QzSA","tabActive":"Tabs_tabActive__3G5VN"};